import PropTypes from 'prop-types'
import { Container, Section } from 'chaoskit/src/components'
import { useState } from 'react'
import { Configure, InstantSearch } from 'react-instantsearch-dom'
import { navigate } from '@reach/router'
import { useTheme } from '@emotion/react'

import PressLayout from '~layouts/PressLayout'
import HelmetSEO from '~partials/global/HelmetSEO'
import {
  createUrl,
  searchStateToUrl,
  urlToSearchState,
} from '~partials/search/utility'
import useAlgoliaSearchClient from '~hooks/useAlgoliaSearchClient'
import {
  CustomInfiniteHits,
  CustomSearchBox,
  DEBOUNCE_TIME,
} from '~partials/search/algolia-global'
import { Hit } from '~partials/search/algolia-resources'
import { CustomCategoryMenu } from '~partials/search/algolia-media'

const PressMedia = ({ location }) => {
  const theme = useTheme()

  const searchClient = useAlgoliaSearchClient((state) => state.searchClient)
  const [searchState, setSearchState] = useState(urlToSearchState(location))
  const [debouncedSetState, setDebouncedSetState] = useState(null)

  const handleSearchStateChange = (updatedSearchState) => {
    clearTimeout(debouncedSetState)

    setDebouncedSetState(
      setTimeout(() => {
        navigate(searchStateToUrl(updatedSearchState), updatedSearchState)
      }, DEBOUNCE_TIME)
    )

    setSearchState(updatedSearchState)
  }

  return (
    <PressLayout>
      <HelmetSEO
        title="Media Coverage for Gremlin"
        description="News, company info, and media resources"
      />
      <Section>
        <Container>
          <InstantSearch
            indexName="resources"
            searchClient={searchClient}
            searchState={searchState}
            onSearchStateChange={handleSearchStateChange}
            createURL={createUrl}
          >
            <Configure
              filters="articleLabel:Media"
              facetingAfterDistinct
              hitsPerPage="60"
            />
            <div
              css={{
                display: 'grid',
                gridTemplateColumns: '1fr',
                gap: theme.space.large,
                marginBottom: theme.space.large,
              }}
            >
              <div
                css={{
                  display: 'grid',
                  gridTemplateColumns: '1fr',
                  justifyContent: 'center',

                  [theme.mq.medium]: {
                    gridTemplateColumns: '0.5fr',
                  },
                }}
              >
                <CustomSearchBox placeholderText="Search media coverage" />
              </div>
              <CustomCategoryMenu attribute="categories" />
            </div>

            <CustomInfiniteHits
              hitTemplate={Hit}
              customCss={{
                [theme.mq.medium]: {
                  gridTemplateColumns: 'repeat(3, 1fr)',
                },
              }}
            />
          </InstantSearch>
        </Container>
      </Section>
    </PressLayout>
  )
}

PressMedia.propTypes = {
  location: PropTypes.object.isRequired,
}

export default PressMedia
